import { useState } from "react";
import { Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Textarea } from "@/components/ui/textarea";
import {
  MOTIVOS_DESCARTE,
  type WhatsAppItem,
  type WhatsAppMotivoDescarte,
} from "@/types/whatsapp";

interface WhatsAppDescartarPopoverProps {
  item: WhatsAppItem;
  descartando: boolean;
  onDescartar: (item: WhatsAppItem, motivo: WhatsAppMotivoDescarte, nota?: string) => void;
}

/** O motivo do descarte é o que ensina o prompt: "errou" sozinho não diz onde.
 * Por isso é um clique só, e não um formulário. */
export function WhatsAppDescartarPopover({
  item,
  descartando,
  onDescartar,
}: WhatsAppDescartarPopoverProps) {
  const [aberto, setAberto] = useState(false);
  const [nota, setNota] = useState("");

  const escolher = (motivo: WhatsAppMotivoDescarte) => {
    onDescartar(item, motivo, nota.trim() || undefined);
    setNota("");
    setAberto(false);
  };

  return (
    <Popover open={aberto} onOpenChange={setAberto}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="h-8 gap-1.5"
          disabled={descartando}
        >
          {descartando ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <X className="h-4 w-4" />
          )}
          Descartar
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 space-y-2 p-3">
        <div className="text-sm font-medium">Por que descartar?</div>
        <div className="space-y-1">
          {MOTIVOS_DESCARTE.map((motivo) => (
            <Button
              key={motivo.valor}
              variant="ghost"
              size="sm"
              className="h-8 w-full justify-start font-normal"
              onClick={() => escolher(motivo.valor)}
            >
              {motivo.label}
            </Button>
          ))}
        </div>
        <Textarea
          placeholder="Detalhe (opcional)"
          value={nota}
          onChange={(evento) => setNota(evento.target.value)}
          rows={2}
          className="text-sm"
        />
      </PopoverContent>
    </Popover>
  );
}
